import React from 'react';
import styled from 'styled-components';
import { FaHistory } from 'react-icons/fa';

const IconButton = styled.button`
  position: relative;
  background-color: ${props => props.theme.colors.primary};
  color: white;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

  &:hover {
    background-color: ${props => props.theme.colors.primaryDark};
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }

  &:active {
    transform: translateY(0);
  }
  
  /* Réduire uniquement sur mobile */
  @media (max-width: 768px) {
    width: 30px;
    height: 30px;
  }
`;

interface ActivityIconProps {
  onClick: () => void;
}

/**
 * Icône pour ouvrir le drawer d'activités
 */
export const ActivityIcon: React.FC<ActivityIconProps> = ({ onClick }) => {
  return (
    <IconButton onClick={onClick} title="Activités">
      <FaHistory size={18} />
    </IconButton>
  );
};
